export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-15-df6ed9f49c9dec59a2cde6f45714e9a0.png";